import {createFileRoute} from '@tanstack/react-router';

import {CreateChecklistTemplateForm} from '@/features/Library/components/ChecklistTemplate/CreateChecklistTemplateForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/checklists/create')({
  component: CreateChecklistTemplateForm,
  beforeLoad: () => makeDocumentTitle('Create Checklist'),
});
